import React from "react";
import StaticPageLayout from "./StaticPageLayout";

const EMAIL = "contact@arcanechronicles.com";
const UPDATED = "2026-04-24";

export default function CookiePolicy() {
  return (
    <StaticPageLayout titleIt="Cookie Policy" titleEn="Cookie Policy">
      {(isIt) => (
        <>
          <p className="text-xs text-[#94a3b8]">{isIt ? "Ultimo aggiornamento" : "Last updated"}: {UPDATED}</p>
          {isIt ? (
            <>
              <h2 className="font-heading text-xl text-[#cfb53b] mt-4">1. Cosa sono i cookie</h2>
              <p>I cookie sono piccoli file di testo memorizzati dal tuo browser per conservare informazioni tra sessioni diverse. Arcane Chronicles utilizza principalmente <strong>localStorage</strong> (tecnicamente simile ai cookie) per mantenere la tua sessione e le preferenze.</p>

              <h2 className="font-heading text-xl text-[#cfb53b]">2. Cosa memorizziamo</h2>
              <ul className="list-disc pl-5">
                <li><strong>Token di sessione JWT</strong> (localStorage key: <code className="text-[#cfb53b]">ac_token</code>): permette al tuo browser di restare loggato. Scade dopo 7 giorni.</li>
                <li><strong>Lingua UI</strong> (<code className="text-[#cfb53b]">ac_lang</code>): la lingua scelta per l'interfaccia.</li>
                <li><strong>Font storia</strong> (<code className="text-[#cfb53b]">ac_story_font</code>): "cursive" o "classic".</li>
                <li><strong>Preferenze audio</strong> (volume musica / effetti sonori).</li>
              </ul>
              <p>Non utilizziamo cookie di terze parti a fini pubblicitari o di tracciamento comportamentale.</p>

              <h2 className="font-heading text-xl text-[#cfb53b]">3. Cookie di terze parti</h2>
              <ul className="list-disc pl-5">
                <li><strong>Stripe</strong>: durante il checkout dei pacchetti Oro, Stripe imposta i propri cookie necessari alla sicurezza del pagamento. Vedi la <a className="text-[#cfb53b]" href="https://stripe.com/cookies-policy/legal" target="_blank" rel="noreferrer">cookie policy di Stripe</a>.</li>
                <li><strong>Cloudinary</strong>: le immagini generate sono servite dal CDN Cloudinary che può impostare cookie tecnici per ottimizzare la consegna.</li>
              </ul>

              <h2 className="font-heading text-xl text-[#cfb53b]">4. Come gestirli</h2>
              <p>Puoi svuotare il localStorage in qualsiasi momento dalle impostazioni del tuo browser. Ciò ti farà uscire automaticamente dall'account; i dati di gioco sul server restano intatti.</p>

              <h2 className="font-heading text-xl text-[#cfb53b]">5. Contatti</h2>
              <p>Per domande su questa Cookie Policy: <a className="text-[#cfb53b]" href={`mailto:${EMAIL}`}>{EMAIL}</a></p>
            </>
          ) : (
            <>
              <h2 className="font-heading text-xl text-[#cfb53b] mt-4">1. What are cookies</h2>
              <p>Cookies are small text files stored by your browser to preserve information across sessions. Arcane Chronicles mainly uses <strong>localStorage</strong> (technically similar to cookies) to keep your session and preferences.</p>

              <h2 className="font-heading text-xl text-[#cfb53b]">2. What we store</h2>
              <ul className="list-disc pl-5">
                <li><strong>JWT session token</strong> (localStorage key: <code className="text-[#cfb53b]">ac_token</code>): keeps you logged in. Expires after 7 days.</li>
                <li><strong>UI language</strong> (<code className="text-[#cfb53b]">ac_lang</code>): your chosen interface language.</li>
                <li><strong>Story font</strong> (<code className="text-[#cfb53b]">ac_story_font</code>): "cursive" or "classic".</li>
                <li><strong>Audio preferences</strong> (music / SFX volume).</li>
              </ul>
              <p>We do not use third-party advertising or behavioral tracking cookies.</p>

              <h2 className="font-heading text-xl text-[#cfb53b]">3. Third-party cookies</h2>
              <ul className="list-disc pl-5">
                <li><strong>Stripe</strong>: during Gold pack checkout, Stripe sets its own cookies required for payment security. See <a className="text-[#cfb53b]" href="https://stripe.com/cookies-policy/legal" target="_blank" rel="noreferrer">Stripe's cookie policy</a>.</li>
                <li><strong>Cloudinary</strong>: generated images are served via Cloudinary's CDN which may set technical cookies to optimize delivery.</li>
              </ul>

              <h2 className="font-heading text-xl text-[#cfb53b]">4. How to manage</h2>
              <p>You can clear localStorage anytime via your browser settings. This will log you out automatically; your game data on the server remains intact.</p>

              <h2 className="font-heading text-xl text-[#cfb53b]">5. Contact</h2>
              <p>For questions about this Cookie Policy: <a className="text-[#cfb53b]" href={`mailto:${EMAIL}`}>{EMAIL}</a></p>
            </>
          )}
        </>
      )}
    </StaticPageLayout>
  );
}
